import { TargetingQueryApi } from '../../../api/targeting/model/targeting-search.api.model';
import { IncludeExcludeModel } from '../../../Common/Misc/models/include-exclude-model';

export class RecipientNegativeoutcomeSearchModel {
    listId?: number;
    searchId?: number;
    link?: string;
    deliveryStatus?: IncludeExcludeModel<string>;
    query: TargetingQueryApi;
    listIds?: number[];
}
